import React from "react";
import { Instagram, MessageCircle, Clock } from "lucide-react";
import {
  buildWhatsAppLink,
  WHATSAPP_DISPLAY,
  INSTAGRAM_URL,
  INSTAGRAM_HANDLE,
} from "../data/menu";
import { BrandSeal, Flourish } from "./brand/Ornaments";

const Footer = () => {
  return (
    <footer
      className="relative bg-[var(--sn-bg-deep)] border-t border-[var(--sn-border)] py-16 overflow-hidden"
      data-testid="footer-section"
    >
      <div className="absolute inset-0 sn-grain pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid md:grid-cols-3 gap-10 md:gap-14 items-start">
          <div className="flex flex-col items-center md:items-start">
            <BrandSeal size={130} />
            <p className="mt-5 text-[var(--sn-cream-soft)]/75 text-sm leading-relaxed max-w-xs text-center md:text-left">
              Massas artesanais feitas à mão, com tradição italiana e
              ingredientes selecionados desde 2015.
            </p>
          </div>

          <div>
            <p className="text-[var(--sn-gold)] tracking-[0.3em] text-xs uppercase mb-5">
              Atendimento
            </p>
            <ul className="space-y-4 text-[var(--sn-cream-soft)]/85">
              <li className="flex items-start gap-3">
                <MessageCircle className="w-4 h-4 text-[var(--sn-gold)] mt-1 shrink-0" />
                <div>
                  <p className="text-xs uppercase tracking-widest text-[var(--sn-gold)]/70 mb-0.5">
                    WhatsApp
                  </p>
                  <a
                    href={buildWhatsAppLink()}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-[var(--sn-gold)] transition-colors"
                    data-testid="footer-whatsapp-link"
                  >
                    {WHATSAPP_DISPLAY}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Instagram className="w-4 h-4 text-[var(--sn-gold)] mt-1 shrink-0" />
                <div>
                  <p className="text-xs uppercase tracking-widest text-[var(--sn-gold)]/70 mb-0.5">
                    Instagram
                  </p>
                  <a
                    href={INSTAGRAM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-[var(--sn-gold)] transition-colors"
                    data-testid="footer-instagram-link"
                  >
                    {INSTAGRAM_HANDLE}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 text-[var(--sn-gold)] mt-1 shrink-0" />
                <div>
                  <p className="text-xs uppercase tracking-widest text-[var(--sn-gold)]/70 mb-0.5">
                    Horário
                  </p>
                  <p>Atendimento sob encomenda pelo WhatsApp</p>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-[var(--sn-gold)] tracking-[0.3em] text-xs uppercase mb-5">
              Navegação
            </p>
            <ul className="grid grid-cols-2 gap-y-3 gap-x-6 text-[var(--sn-cream-soft)]/85">
              <li>
                <a
                  href="#sobre"
                  className="hover:text-[var(--sn-gold)] transition-colors"
                  data-testid="footer-nav-sobre"
                >
                  Sobre
                </a>
              </li>
              <li>
                <a
                  href="#cardapio"
                  className="hover:text-[var(--sn-gold)] transition-colors"
                  data-testid="footer-nav-cardapio"
                >
                  Cardápio
                </a>
              </li>
              <li>
                <a
                  href="#galeria"
                  className="hover:text-[var(--sn-gold)] transition-colors"
                  data-testid="footer-nav-galeria"
                >
                  Galeria
                </a>
              </li>
              <li>
                <a
                  href="#diferenciais"
                  className="hover:text-[var(--sn-gold)] transition-colors"
                  data-testid="footer-nav-diferenciais"
                >
                  Diferenciais
                </a>
              </li>
              <li>
                <a
                  href="#depoimentos"
                  className="hover:text-[var(--sn-gold)] transition-colors"
                  data-testid="footer-nav-depoimentos"
                >
                  Depoimentos
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  className="hover:text-[var(--sn-gold)] transition-colors"
                  data-testid="footer-nav-faq"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex justify-center text-[var(--sn-gold)]/60">
          <Flourish className="w-44 h-5" />
        </div>

        <div className="mt-8 pt-6 border-t border-[var(--sn-border)] flex flex-col sm:flex-row items-center justify-between gap-3 text-[var(--sn-cream-soft)]/55 text-xs">
          <p>
            © {new Date().getFullYear()} Santo Nhoque — Massas Artesanais. Todos
            os direitos reservados.
          </p>
          <p className="font-serif-alt italic">
            Feito à mão · Com amor · Desde 2015
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
